"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AttachmentsController", {
    enumerable: true,
    get: function() {
        return AttachmentsController;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _common = require("@nestjs/common");
const _platformexpress = require("@nestjs/platform-express");
const _express = require("express");
const _contentdisposition = /*#__PURE__*/ _interop_require_default(require("content-disposition"));
const _nocodbsdk = require("nocodb-sdk");
const _isuploadallowedinterceptor = require("~/interceptors/is-upload-allowed/is-upload-allowed.interceptor");
const _globalguard = require("~/guards/global/global.guard");
const _attachmentsservice = require("~/services/attachments.service");
const _models = require("~/models");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _config = require("~/interface/config");
const _attachmentHelpers = require("~/helpers/attachmentHelpers");
const _datatableservice = require("~/services/data-table.service");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let AttachmentsController = class AttachmentsController {
    async upload(files, req, scope) {
        var _req_query_path, _req_query;
        const attachments = await this.attachmentsService.upload({
            files: files,
            path: (_req_query = req.query) == null ? void 0 : (_req_query_path = _req_query.path) == null ? void 0 : _req_query_path.toString(),
            req,
            scope
        });
        return attachments;
    }
    async uploadViaURL(body, path, req, scope) {
        const attachments = await this.attachmentsService.uploadViaURL({
            urls: body,
            path,
            req,
            scope
        });
        return attachments;
    }
    // @Get(/^\/download\/(.+)$/)
    // , getCacheMiddleware(), catchError(fileRead));
    async fileRead(filename, res, queryFilename) {
        try {
            const file = await this.attachmentsService.getFile({
                path: _path.default.join('nc', 'uploads', filename)
            });
            if (!await (0, _attachmentHelpers.localFileExists)(file.path)) {
                return res.status(404).send('File not found');
            }
            if ((0, _attachmentHelpers.isPreviewAllowed)({
                mimetype: file.type,
                path: file.path
            })) {
                if (queryFilename) {
                    res.setHeader('Content-Disposition', (0, _contentdisposition.default)(queryFilename, {
                        type: 'attachment'
                    }));
                }
                res.sendFile(file.path);
            } else {
                res.download(file.path, queryFilename);
            }
        } catch (e) {
            res.status(404).send('Not found');
        }
    }
    // @Get(/^\/dl\/([^/]+)\/([^/]+)\/(.+)$/)
    async fileReadv2(param1, param2, filename, res, queryFilename) {
        try {
            const file = await this.attachmentsService.getFile({
                path: _path.default.join('nc', param1, param2, 'uploads', ...filename.split('/'))
            });
            if (!await (0, _attachmentHelpers.localFileExists)(file.path)) {
                return res.status(404).send('File not found');
            }
            if ((0, _attachmentHelpers.isPreviewAllowed)({
                mimetype: file.type,
                path: file.path
            })) {
                if (queryFilename) {
                    res.setHeader('Content-Disposition', (0, _contentdisposition.default)(queryFilename, {
                        type: 'attachment'
                    }));
                }
                res.sendFile(file.path);
            } else {
                res.download(file.path, queryFilename);
            }
        } catch (e) {
            res.status(404).send('Not found');
        }
    }
    async fileReadv3(param, res) {
        try {
            const fullPath = await _models.PresignedUrl.getPath(`dltemp/${param}`);
            const queryHelper = fullPath.split('?');
            const fpath = queryHelper[0];
            let queryResponseContentType = null;
            let queryResponseContentDisposition = null;
            let queryResponseContentEncoding = null;
            if (queryHelper.length > 1) {
                const query = new URLSearchParams(queryHelper[1]);
                queryResponseContentType = query.get('ResponseContentType');
                queryResponseContentDisposition = query.get('ResponseContentDisposition');
                queryResponseContentEncoding = query.get('ResponseContentEncoding');
            }
            const targetParam = param.split('/')[2];
            const filePath = _attachmentHelpers.ATTACHMENT_ROOTS.includes(targetParam) ? '' : 'uploads';
            const file = await this.attachmentsService.getFile({
                path: _path.default.join('nc', filePath, fpath)
            });
            if (!await (0, _attachmentHelpers.localFileExists)(file.path)) {
                return res.status(404).send('File not found');
            }
            if (queryResponseContentType) {
                res.setHeader('Content-Type', queryResponseContentType);
                if (queryResponseContentEncoding) {
                    res.setHeader('Content-Type', `${queryResponseContentType}; charset=${queryResponseContentEncoding}`);
                }
            }
            if (queryResponseContentDisposition) {
                res.setHeader('Content-Disposition', queryResponseContentDisposition);
            }
            if (queryResponseContentEncoding) {
                res.setHeader('Content-Encoding', queryResponseContentEncoding);
            }
            res.sendFile(file.path);
        } catch (e) {
            res.status(404).send('Not found');
        }
    }
    async downloadAttachment(context, modelId, columnId, rowId, urlOrPath) {
        const column = await _models.Column.get(context, {
            colId: columnId
        });
        if (!column) {
            _catchError.NcError.fieldNotFound(columnId);
        }
        const record = await this.dataTableService.dataRead(context, {
            baseId: context.base_id,
            modelId,
            rowId,
            query: {
                fields: column.title
            }
        });
        if (!record) {
            _catchError.NcError.recordNotFound(rowId);
        }
        return this.attachmentsService.getAttachmentFromRecord({
            record,
            column,
            urlOrPath
        });
    }
    constructor(attachmentsService, dataTableService){
        this.attachmentsService = attachmentsService;
        this.dataTableService = dataTableService;
    }
};
_ts_decorate([
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _common.Post)([
        '/api/v1/db/storage/upload',
        '/api/v2/storage/upload'
    ]),
    (0, _common.HttpCode)(200),
    (0, _common.UseInterceptors)(_isuploadallowedinterceptor.UploadAllowedInterceptor, (0, _platformexpress.AnyFilesInterceptor)()),
    _ts_param(0, (0, _common.UploadedFiles)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Query)('scope')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof Array === "undefined" ? Object : Array,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _nocodbsdk.PublicAttachmentScope === "undefined" ? Object : _nocodbsdk.PublicAttachmentScope
    ]),
    _ts_metadata("design:returntype", Promise)
], AttachmentsController.prototype, "upload", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/storage/upload-by-url',
        '/api/v2/storage/upload-by-url'
    ]),
    (0, _common.HttpCode)(200),
    (0, _common.UseInterceptors)(_isuploadallowedinterceptor.UploadAllowedInterceptor),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Body)()),
    _ts_param(1, (0, _common.Query)('path')),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Query)('scope')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof Array === "undefined" ? Object : Array,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _nocodbsdk.PublicAttachmentScope === "undefined" ? Object : _nocodbsdk.PublicAttachmentScope
    ]),
    _ts_metadata("design:returntype", Promise)
], AttachmentsController.prototype, "uploadViaURL", null);
_ts_decorate([
    (0, _common.Get)('/download/:filename(*)'),
    _ts_param(0, (0, _common.Param)('filename')),
    _ts_param(1, (0, _common.Res)()),
    _ts_param(2, (0, _common.Query)('filename')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], AttachmentsController.prototype, "fileRead", null);
_ts_decorate([
    (0, _common.Get)('/dl/:param1([a-zA-Z0-9_-]+)/:param2([a-zA-Z0-9_-]+)/:filename(*)'),
    _ts_param(0, (0, _common.Param)('param1')),
    _ts_param(1, (0, _common.Param)('param2')),
    _ts_param(2, (0, _common.Param)('filename')),
    _ts_param(3, (0, _common.Res)()),
    _ts_param(4, (0, _common.Query)('filename')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        String,
        String,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], AttachmentsController.prototype, "fileReadv2", null);
_ts_decorate([
    (0, _common.Get)('/dltemp/:param(*)'),
    _ts_param(0, (0, _common.Param)('param')),
    _ts_param(1, (0, _common.Res)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        String,
        typeof _express.Response === "undefined" ? Object : _express.Response
    ]),
    _ts_metadata("design:returntype", Promise)
], AttachmentsController.prototype, "fileReadv3", null);
_ts_decorate([
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    (0, _common.Get)('/api/v2/downloadAttachment/:modelId/:columnId/:rowId'),
    (0, _extractidsmiddleware.Acl)('dataRead'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('modelId')),
    _ts_param(2, (0, _common.Param)('columnId')),
    _ts_param(3, (0, _common.Param)('rowId')),
    _ts_param(4, (0, _common.Query)('urlOrPath')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], AttachmentsController.prototype, "downloadAttachment", null);
AttachmentsController = _ts_decorate([
    (0, _common.Controller)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _attachmentsservice.AttachmentsService === "undefined" ? Object : _attachmentsservice.AttachmentsService,
        typeof _datatableservice.DataTableService === "undefined" ? Object : _datatableservice.DataTableService
    ])
], AttachmentsController);
